import { Table } from "antd";
import React from "react";
import BannerCard from "../../common/components/BannerCard";
import useDashboard from "./useDashboard";

const DashboardEmails = () => {
  const { data, emailsColumns, loading } = useDashboard();

  return (
    <BannerCard title="Emails">
      <Table loading={loading} dataSource={data?.emails} size="small" columns={emailsColumns} scroll={{ x: 480 }} />
    </BannerCard>
  );
};

export default DashboardEmails;
